import { useDispatch, TypedUseSelectorHook, useSelector } from 'react-redux';
import type { RootState } from './store';
import type { ThunkDispatch } from 'redux-thunk';
import type { AnyAction } from 'redux';

/* selector tipado */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

/* 👇 dispatcher que admite thunks */
export type AppThunkDispatch = ThunkDispatch<RootState, unknown, AnyAction>;
export const useAppDispatch = () => useDispatch<AppThunkDispatch>();
